import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React from 'react';
import Chart from 'react-apexcharts';

const GraficoArea = ({ descricaoCategorias = [], categorias = descricaoCategorias, conteudo = [], height }) => {
  return (
    <Chart
      options={{
        chart: {
          toolbar: {
            show: false,
          },
        },
        colors: ['#22D3EE', '#252F3E'],
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: ['gradient', 'gradient'],
          colors: [process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#36B5CB' : '#3DA4BC', '#666D78'],
          shade: 'dark',
          gradient: {
            opacityFrom: 1,
            opacityTo: 0.5,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: false,
          theme: 'dark',
        },
        xaxis: {
          labels: {
            rotate: 0,
          },
          categories: descricaoCategorias,
          overwriteCategories: categorias,
        },
        yaxis: {
          show: true,
          labels: {
            formatter(value) {
              return getCurrencySemSinalMonetario(value);
            },
          },
        },
      }}
      series={conteudo}
      type="area"
      height={height}
    />
  );
};

export default GraficoArea;
